import React from 'react';
import { useSelector } from 'react-redux';
import { FormikProps } from 'formik';
import { PersonInfoFields } from '../../components/forms/person-fields';
import { getPersonalInfoPersonFieldsRequiredSchema } from './personal-form-models';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { FormField } from '../../../../global/components/form-element/form-field';
import { TcsmStates } from '../../../../root/tcsm-model';
import { parseLov } from '../../../../global/helpers/form-data-helper';
import { Person } from '../../../../global/models/person-model';
import { FieldAutomationIds } from '../../../../Global/constants/field-automation-ids';

interface BasicInfoProps {
	labelSetting: LabelSettingProps,
	formikProps: FormikProps<any>,
	salutationRequired?: boolean;
	dobOptional?: boolean;
	taxIdOptional?: boolean;
	renderDob?: boolean;
	renderTaxId?: boolean;
	currentPerson?: Person;
	docUpload?: boolean;	
	dobWarningMessage?: JSX.Element;
	plusSixtyFive?: boolean;
	overrideDocUpload?: { taxId: boolean, dob: boolean, gender: boolean };
}

export function BasicInfo(props: BasicInfoProps) {
	const { formikProps, docUpload, plusSixtyFive } = props;

	const salutations = useSelector<TcsmStates, any>(state => state.lovProcState?.personLov?.salutation_designation);
	const mappedSalutation = salutations ? parseLov(salutations) : [];

	return (
		<FormGroup>
			<FormField
				name='designation_salutation'
				label={props.labelSetting.salutationLabel}
				component='input'
				options={mappedSalutation}
				errors={formikProps.errors}
				touched={formikProps.touched}
				select
				required={props.salutationRequired}
				testId={FieldAutomationIds.salutationDropdown}
			/>
			<PersonInfoFields
				renderKnownAs
				formikProps={formikProps}
				requiredSchema={getPersonalInfoPersonFieldsRequiredSchema(props.dobOptional, props.taxIdOptional)}
				renderDob={props.renderDob}
				renderTaxId={props.renderTaxId}
				currentPerson={props.currentPerson}				
				docUpload={docUpload}
				dobWarningMessage={props.dobWarningMessage}
				plusSixtyFive={plusSixtyFive}
				overrideDocUpload={props.overrideDocUpload}
			/>
		</FormGroup>
	);
}

BasicInfo.defaultProps = {
	dobOptional: false,
	taxIdOptional: false,
	renderDob: true,
	renderTaxId: true,
	salutationRequired: false,
	currentPerson: null,
	docUpload: false,	
	dobWarningMessage: null,
	plusSixtyFive: false,
	overrideDocUpload: { taxId: false, dob: false, gender: false },
};
